import { TncConsentConditionVM } from '@porterin/booking-flow/src/auth/domain/entities/auth-content/AuthContentVM.type';
import { AgreedDocs } from '@porterin/booking-flow/src/order-review/domain/entities/AgreedDocs';
import { AgreedDocsConfig } from '@porterin/component-library/src/domain/country/type';

export function getConsentTerms(
  conditions: TncConsentConditionVM[],
  default_agreed_docs: AgreedDocsConfig,
  agreed_docs?: AgreedDocs,
) {
  const tncUrl = default_agreed_docs.tncUrl ?? agreed_docs?.tncUrl ?? '';
  const privacyPolicyUrl =
    default_agreed_docs.privacyPolicyUrl ?? agreed_docs?.privacyPolicyUrl ?? '';

  return conditions.map(condition => ({
    ...condition,
    text: condition.text
      .replace('{{tncUrl}}', tncUrl)
      .replace('{{privacyPolicyUrl}}', privacyPolicyUrl),
  }));
}
